import _export from '../internals/export.js';
import hasOwnProperty_1 from '../internals/has-own-property.js';

var $ = _export;
var hasOwn = hasOwnProperty_1; // `Object.hasOwn` method
// https://github.com/tc39/proposal-accessible-object-hasownproperty

$({
  target: 'Object',
  stat: true
}, {
  hasOwn: hasOwn
});
